import CareerPath from './CareerPath'
export default CareerPath
